export default __webpack_public_path__ + "static/media/avatar.e63c138f.svg";